import React from "react";
import "./style.css";
import {
  AiOutlineInstagram,
  AiOutlineTwitter,
  AiFillLinkedin,
} from "react-icons/ai";
import { BsFacebook } from "react-icons/bs";

function ContactUs() {
  return (
    <>
      <div className="container mx-auto grid grid-cols-12 lg:px-20 md:px-10 px-2 md:mt-44  mt-20 md:gap-10 gap-1 ">
        <div className="lg:col-span-3 md:col-span-6 col-span-12  md:mb-20 mb-5">
          <div className="text-gray-400 mb-2">Contact us</div>
          <div className="text-3xl font-bold mb-5 ">
            Looking for more information?
          </div>
          <div className="text-gray-400 mb-5 text-sm leading-5">
            Qui soluta quis libero laudantium facilis. Eum mollitia culpa. Aut
            inventore rerum itaque quisquam repellat.
          </div>
          <div className="text-primary mb-2">Follow us</div>
          <div className="flex  text-primary font-bold">
            <div>
              <AiOutlineInstagram className="text-xl " />
            </div>
            <div>
              <BsFacebook className="text-xl ml-3" />
            </div>
            <div>
              <AiOutlineTwitter className="text-xl ml-3" />
            </div>
            <div>
              <AiFillLinkedin className="text-xl ml-3" />
            </div>
          </div>
        </div>
        <div className="lg:col-span-6 lg:block hidden telephone mt-10"></div>

        <div className="lg:col-span-3 md:col-span-6 col-span-12">
          <div className="flex flex-col items-between  h-full ">
            <div className="md:mt-8 mt-2">
              <input
                type="text"
                className="w-full bg-[#F7D3D8] rounded-full pt-3 pb-3 pl-5 mb-2"
                placeholder="Email Address"
              />
              <input
                className="w-full bg-[#F7D3D8] rounded-full pt-3 pb-3  pl-5"
                placeholder="passwords"
              />
            </div>
            <button className="bg-primary rounded-full pt-3 pb-3 mb-3 mt-5 text-white">
              Contact us
            </button>
          </div>
        </div>
      </div>
      <div className="col-span-12 text-center text-sm pt-2 pb-2 bg-primary text-white">
        © 2022 The Media Ant - A Haystack Marketing Services Pvt.Ltd. brand. All
        icons and images © to their respective owners.
      </div>
    </>
  );
}

export default ContactUs;
